import styled from 'styled-components'

export const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 5px;
  line-height: 18px;
  font-size: 14px;
`
export const THead = styled.thead`
  text-transform: uppercase;
  font-weight: bold;
  font-size: 12px;
  line-height: 16px;
  border-spacing: 0;
`
export const Row = styled.tr<{ selected?: boolean; selectedColor?: string }>`
  padding: 5px 10px;
  ${({ selected, selectedColor, theme }) =>
    selected &&
    `
    background: ${selectedColor || theme.colors.light};
  `}
  :hover {
    background: ${({ selected, selectedColor, theme }) =>
      selected ? selectedColor : theme.colors.light};
  }
  td:first-child {
    padding-left: 5px;
  }
`
export const Column = styled.td<{ align?: string; width?: number }>`
  ${({ align }) => align && `text-align: ${align};`}
  ${({ width }) => width && `width: ${width}px;`}
`
